import React from 'react'
function InvoiceItemFooterStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .content-footer-container {
          /*background-color: pink;*/
          display: flex;
          font-size: 1rem;
          padding: 5px;
          justify-content: flex-end;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export default React.memo(InvoiceItemFooterStyle)
